module.exports = __webpack_public_path__ + "img/sleeve front armhole length.84ac8e6d.png";